import React, { useLayoutEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import ProjectCard from './projectCard';
import './featuredProjects.css';

export default function FeaturedProjects() {
  const [hovered, setHovered] = useState(null);
  const [focused, setFocused] = useState(null);
  const [selected, setSelected] = useState(null);
  const active = hovered || focused || selected;
  const cardsRef = useRef(null);
  const animateRef = useRef(null);
  const activeRef = useRef(active);
  activeRef.current = active;

  useLayoutEffect(() => {
    if (!window.matchMedia) return undefined;
    const media = gsap.matchMedia();
    media.add('(min-width: 701px) and (prefers-reduced-motion: no-preference)', (context) => {
      const container = cardsRef.current;
      const cards = [...container.children];
      container.dataset.gsap = 'true';
      const grow = (index, id) => !id ? 1 : projects[index].id === id ? 10 : .65;
      gsap.set(cards, { flexGrow: (index) => grow(index, activeRef.current) });
      context.add('expand', (id) => {
        gsap.to(cards, { flexGrow: (index) => grow(index, id), duration: .85, ease: 'power3.out', overwrite: 'auto' });
      });
      animateRef.current = context.expand;
      return () => { delete container.dataset.gsap; animateRef.current = null; };
    });
    return () => media.revert();
  }, []);

  useLayoutEffect(() => { animateRef.current?.(active); }, [active]);

  return (
    <section className="featured-projects" id="projects" aria-labelledby="projects-heading">
      <div className="featured-projects__heading">
        <h2 id="projects-heading" tabIndex="-1">Featured Projects</h2>
        <Link className="featured-projects__cta" to="/projects">View All Projects <span aria-hidden="true">↗︎</span></Link>
      </div>
      <div ref={cardsRef} className={`featured-projects__cards${active ? ' has-active' : ''}`}
        onPointerLeave={() => setHovered(null)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            setHovered(null); setFocused(null); setSelected(null);
          }
        }}>
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} active={active === project.id}
            onHover={setHovered} onFocus={setFocused} onBlur={() => setFocused(null)}
            onSelect={(id) => setSelected((previous) => previous === id ? null : id)} />
        ))}
      </div>
    </section>
  );
}
